var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYacht2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06687 16.0052C2.17397 16.0052 1.67755 17.0519 2.23535 17.7584L5.26432 21.595C5.4664 21.851 5.77235 22 6.09584 22H17.9042C18.2276 22 18.5336 21.851 18.7357 21.595L21.7647 17.7584C22.3224 17.0519 21.826 16.0052 20.9331 16.0052H3.06687Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24054 16.0651H19.9541C19.9502 16.0451 19.9462 16.0251 19.9423 16.0052H7.26329L7.24054 16.0651Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87415 14.3865H19.5561C18.4708 10.4918 16.3376 6.96602 13.3803 4.21262L11.261 2.23934C10.6354 1.65685 9.63821 2.21743 9.79478 3.06361C10.4964 6.85548 10.1772 10.7665 8.87415 14.3865Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYacht2);
export default __webpack_public_path__ + "static/media/yacht-2.3e5115bea467281fd990f0bdf8c80a71.svg";
export { ForwardRef as ReactComponent };